import './Shared/Main/Live/ModeTableLive.js';
import './Shared/Main/Live/TableFetcherLive.js';
import './Shared/Main/Live/BinderLive.js';
import './Shared/Main/Live/BinderLiveFavorites.js';
import './Shared/Main/Live/BinderLiveSingleSport.js';
import './Shared/Main/Live/BinderTextScroll.ts';

import './Shared/Main/Prematch/ModeTablePrematch.js';
import './Shared/Main/Prematch/BinderPrematch.js';
import './Shared/Main/Prematch/BinderPrematchFavorites.js';
import './Shared/Main/Prematch/BinderPrematchSingleSport.js';

import './Shared/Main/Event/EventBlock.js';
import './Shared/Main/Event/OpenEvent.js';
import './Shared/Main/Event/binder.js';

import './Shared/Main/Tickets/Tickets.js';

import './Shared/Main/History/binder.js';
import './Shared/Main/SuperExpress/binder.js';

import './Shared/Main/Results/Results.js';
import './Shared/Main/Results/binder.js';

import './Shared/Main/Bonuses/binder.js';

import './Shared/Routing/navigo.js';
import './Shared/Routing/spa.js';
